import {
  FormDatePickerV2Input,
  FormInputController,
  FormNumberInputV2,
  FormSwitchInputV2,
  FormTextInputV2,
} from '@wajeez-web/components/form-builder';
import { Server } from '@wajeez/wajeez.microservices';
import { FieldValues, UseControllerProps } from 'react-hook-form';
import { Autocomplete } from '@wajeez-web/components/mui';
import { mediaMimeTypes } from '@wajeez-web/core/utils';
import { useContentSelector } from '@wajeez-web/stores/content';

import { FormInput } from './CollectionComponentTypeFormBuilder';
import { SelectCreatorV2 } from '@wajeez-web/components/ui';

interface CollectionComponentTypeFieldOptionsComponentsProps<
  FormInput extends FieldValues
> extends UseControllerProps<FormInput> {
  fieldType: Server.FieldType | undefined;
  fieldIndex: number;
}

export const CollectionComponentTypeFieldOptionsComponents = ({
  fieldType,
  fieldIndex,
  control,
}: CollectionComponentTypeFieldOptionsComponentsProps<FormInput>) => {
  const componentTypesLookups = useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypesLookups
  );

  const renderFieldOptionsComponents = () => {
    switch (fieldType) {
      case Server.FieldType.Text:
        return (
          <>
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.minLength`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Min Length',
                placeHolder: 'Min Length',
                fieldOptions: { min: 1 },
              }}
            />
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.maxLength`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Max Length',
                placeHolder: 'Max Length',
                fieldOptions: { min: 1 },
              }}
            />
          </>
        );
      case Server.FieldType.AreaText:
        return (
          <>
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.minLength`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Min Length',
                placeHolder: 'Min Length',
                fieldOptions: { min: 1 },
              }}
            />
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.maxLength`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Max Length',
                placeHolder: 'Max Length',
                fieldOptions: { min: 1 },
              }}
            />
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.rows`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Rows',
                placeHolder: 'Rows',
                fieldOptions: { min: 1 },
              }}
            />
          </>
        );
      case Server.FieldType.TineMCE:
        return (
          <>
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.minLength`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Min Length',
                placeHolder: 'Min Length',
                fieldOptions: { min: 1 },
              }}
            />
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.maxLength`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Max Length',
                placeHolder: 'Max Length',
                fieldOptions: { min: 1 },
              }}
            />
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.height`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Height',
                placeHolder: 'Height',
                fieldOptions: { min: 1 },
              }}
            />
          </>
        );
      case Server.FieldType.Date:
      case Server.FieldType.DateTime:
        return (
          <>
            <FormDatePickerV2Input
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.minDate`}
              fieldMeta={{
                fieldType: Server.FieldType.DateTime,
                label: 'Min Date',
                placeHolder: 'Min Date',
                fieldOptions: {},
              }}
            />
            <FormDatePickerV2Input
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.maxDate`}
              fieldMeta={{
                fieldType: Server.FieldType.DateTime,
                label: 'Max Date',
                placeHolder: 'Max Date',
                fieldOptions: {},
              }}
            />
          </>
        );
      case Server.FieldType.DragFile:
      case Server.FieldType.UploadFile:
      case Server.FieldType.UploadImage:
        return (
          <>
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.upToKB`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Size Up To (KB)',
                placeHolder: 'Size Up To (KB)',
                fieldOptions: {},
              }}
            />
            <FormTextInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.uploadEndPoint`}
              fieldMeta={{
                fieldType: Server.FieldType.Text,
                label: 'Upload Endpoint',
                placeHolder: 'Upload Endpoint',
                fieldOptions: {},
              }}
            />
            <div className="col-span-2">
              <FormInputController
                control={control}
                name={`fields.${fieldIndex}.fieldOptions.types`}
                fieldMeta={{
                  fieldType: Server.FieldType.Select,
                  fieldOptions: {},
                }}
                renderInput={({ ...props }) => (
                  <div className="h-fit">
                    <Autocomplete
                      id={`types-autocomplete-${fieldIndex}`}
                      options={mediaMimeTypes.map((m) => {
                        return {
                          value: m,
                          label: m,
                        };
                      })}
                      label="Types"
                      color="#1f7983"
                      heightClassName="h-full"
                      multiple
                      {...props}
                    />
                  </div>
                )}
              />
            </div>
          </>
        );
      case Server.FieldType.CallbackSelect:
        return (
          <>
            <FormSwitchInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.isMulti`}
              fieldMeta={{
                fieldType: Server.FieldType.Switch,
                label: 'Is Multi?',
                fieldOptions: {},
              }}
            />
            <FormSwitchInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.withOrder`}
              fieldMeta={{
                fieldType: Server.FieldType.Switch,
                label: 'With Order?',
                fieldOptions: {},
              }}
            />
            <FormTextInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.optionsListEndPoint`}
              fieldMeta={{
                fieldType: Server.FieldType.Text,
                label: 'Options List Endpoint',
                placeHolder: 'Options List Endpoint',
                fieldOptions: {},
              }}
            />
          </>
        );
      case Server.FieldType.Select:
        return (
          <>
            <FormSwitchInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.isMulti`}
              fieldMeta={{
                fieldType: Server.FieldType.Switch,
                label: 'Is Multi?',
                fieldOptions: {},
              }}
            />
            <FormSwitchInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.withOrder`}
              fieldMeta={{
                fieldType: Server.FieldType.Switch,
                label: 'With Order?',
                fieldOptions: {},
              }}
            />
            <div className="col-span-2">
              <FormInputController
                name={`fields.${fieldIndex}.fieldOptions.selectOptions`}
                control={control}
                fieldMeta={{ fieldType: Server.FieldType.Select }}
                renderInput={({ onChange }) => {
                  return (
                    <SelectCreatorV2
                      name={`fields.${fieldIndex}.fieldOptions.selectOptions`}
                      label="Select Options"
                      onChange={(value) => {
                        onChange(value);
                      }}
                    />
                  );
                }}
              />
            </div>
          </>
        );
      case Server.FieldType.Number:
        return (
          <>
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.min`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Min',
                placeHolder: 'Min',
                fieldOptions: {},
              }}
            />
            <FormNumberInputV2
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.max`}
              fieldMeta={{
                fieldType: Server.FieldType.Number,
                label: 'Max',
                placeHolder: 'Max',
                fieldOptions: {},
              }}
            />
          </>
        );
      case Server.FieldType.RequiredComponent:
        return (
          <div className="col-span-2">
            <FormInputController
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.typeId`}
              fieldMeta={{
                fieldType: Server.FieldType.Select,
                fieldOptions: {},
              }}
              renderInput={({ ...props }) => (
                <div className="h-fit">
                  <Autocomplete
                    id={`typeId-autocomplete-${fieldIndex}`}
                    options={componentTypesLookups.data.map((t) => {
                      return {
                        value: t.id,
                        label: t.title,
                      };
                    })}
                    label="Type"
                    color="#1f7983"
                    {...props}
                  />
                </div>
              )}
            />
          </div>
        );
      case Server.FieldType.PredefinedComponent:
        return (
          <div className="col-span-2">
            <FormInputController
              control={control}
              name={`fields.${fieldIndex}.fieldOptions.allowedPredefinedComponents`}
              fieldMeta={{
                fieldType: Server.FieldType.Select,
                fieldOptions: {},
              }}
              renderInput={({ ...props }) => (
                <div className="h-fit">
                  <Autocomplete
                    id={`allowedPredefinedComponents-autocomplete-${fieldIndex}`}
                    options={[]}
                    label="Allowed Predefined Components"
                    color="#1f7983"
                    heightClassName="h-full"
                    multiple
                    freeSolo
                    {...props}
                  />
                </div>
              )}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return <>{renderFieldOptionsComponents()}</>;
};
